import { Map, OrderedSet } from 'immutable';

import * as constants from './../constants';

const initialState = Map({
  filter: Map({
    selectedItems: OrderedSet(),
  }),
  searchTerm: '',
});

const appStorageFilterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.SET_APP_STORAGE_FILTER_ITEMS:
      return state.setIn(['filter', 'selectedItems'], payload.items);
    case constants.SET_APP_STORAGE_SEARCH_TERM:
      return state.set('searchTerm', payload);
    default:
      return state;
  }
};

export default appStorageFilterReducer;
export { initialState };
